export enum BetType{
    closeAbove,
    closeBellow,   
}

export enum PlayAreaState{
    close,
    open,
    lower
}
